import { useLazyQuery, useMutation } from "@apollo/client/react";
import toast from "react-hot-toast";
import eventBus, {AuthenticationLoggedInEvent} from "../state/EventBus";
import {PmStore} from "@/state";
import { gql } from "@apollo/client";



const queryGetLegalEntityZumrailsAchConnectToken = gql`
  query legalEntityGetZumrailsAchConnectToken($organizationId: UUID!, $legalEntityId: UUID!) { 
    legalEntityGetZumrailsAchConnectToken(organizationId: $organizationId, legalEntityId: $legalEntityId) 
 }
`;



const mutationConnectLegalEntityZumrailsBankAccount = gql`
  mutation legalEntityConnectZumrailsAch($organizationId: UUID!, $legalEntityId: UUID!,  $zumrailsUserId: UUID!) { 
    legalEntityConnectZumrailsAch(organizationId: $organizationId, legalEntityId: $legalEntityId zumrailsUserId: $zumrailsUserId) {
        id
    }
 }
`;




export function useZumrailsActions() {
    const state = PmStore();
    const [apiGetLegalEntityZumrailsAchConnectToken] = useLazyQuery(queryGetLegalEntityZumrailsAchConnectToken);
    const [apiConnectLegalEntityZumrailsBankAccount] = useMutation(mutationConnectLegalEntityZumrailsBankAccount);




    function LegalEntityConnectBankAccount(legalEntityId: string, zumrailsUserId: String)
    {
        let organizationId = state?.selectedOrganization?.id;

        return new Promise(async (resolve, reject) => {
            apiConnectLegalEntityZumrailsBankAccount({
                variables:{
                    organizationId,
                    legalEntityId,
                    zumrailsUserId
                }
            }).then((result: any) => {
                resolve(result?.data?.legalEntityConnectZumrailsAch);
            })
            .catch( (error) => {
                toast.error("Api Error, Unable to connect bank account.");
                reject(error);
            })
        })
    }



   function GetLegalEntityZumrailsAchConnectToken(legalEntityId: string)
    {
        let organizationId = state?.selectedOrganization?.id;

        return new Promise(async (resolve, reject) => {
            apiGetLegalEntityZumrailsAchConnectToken({
                variables:{
                    organizationId,
                    legalEntityId
                }
            }).then((result: any) => {
                resolve(result?.data?.legalEntityGetZumrailsAchConnectToken);
            })
            .catch( (error) => {
                toast.error("Api Error, Unable to get zumrails connect token");
                reject(error);
            })
        })
    }

   

    return {
        GetLegalEntityZumrailsAchConnectToken,
        LegalEntityConnectBankAccount
    };
}
